<div class="externe-daten">
  <cap-content-header>
    <cap-title>
      {{ "GefundeneBauprojekte" | translate }}
    </cap-title>
    <cap-title-functionbar>
      <cap-functionbar-searchresult-buttons [listLoader]="listLoader"></cap-functionbar-searchresult-buttons>
    </cap-title-functionbar>
  </cap-content-header>

  <cap-gwr-bauprojekt-table [listLoader]="listLoader" [showZeilenSelect]="false"></cap-gwr-bauprojekt-table>
</div>
